import LocalizedStrings from 'react-localization';

import { ControlLocalizationENUS } from './en-US';

// Custom strings used for non-DB fields.
export const strings = new LocalizedStrings({ 'en-US': ControlLocalizationENUS });

// Dynamically load other locales if needed.
export const setLocale = async (locale: string) => {
    switch (locale) {
        case 'en-CA': {
            const holdResult = await import('./en-CA');
            strings.setContent({ 'en-CA': holdResult.ControlLocalizationENCA });
            break;
        }
        case 'fr-CA': {
            const holdResult = await import('./fr-CA');
            strings.setContent({ 'fr-CA': holdResult.ControlLocalizationFRCA });
            break;
        }
        default: {
            strings.setContent({ 'en-US': ControlLocalizationENUS });
            break;
        }
    }
};

// Get the DB String based on the name given
// Export with supported locales.
